import Typography from '@mui/material/Typography/Typography';
import Paper from '@mui/material/Paper/Paper';
import EnhancedTextArea from './EnhancedTextArea';
import Row from 'reactstrap/es/Row';
import { Col } from 'reactstrap';
import { useState } from 'react';
import * as Utils from "../components/Utils.js";


interface FormTextAreaProps {
   name: string,
   label?: React.ReactNode,
   value?: string | null,
   editable?: boolean,
   optional?: boolean,
   hidden?: boolean,
   className?: string,
   onValueChanged?: (name: string, value?: string | null) => void;
}

export const FormTextArea = ({ name, label, value, editable, optional, hidden, onValueChanged, className }: FormTextAreaProps) => {
   const [cache, setCache] = useState<string | null | undefined>(value);
   if (hidden || (optional && !value && !editable)) {
      return null;
   }

   return (
      <>
         <Row>
            <Col colSpan={2} className='fill-cell'>
               {(label) ? label : <Typography variant="body1" sx={{ fontWeight: 'bolder', mb: 10 }}>{label}</Typography>}
            </Col>
         </Row>
         {(editable) ?
            <Row className={"p-0 m-0 mt-3" + className}>
               <Col xs="12" className="p-1 m-0">
                  <EnhancedTextArea
                     label={name}
                     value={cache}
                     onValueChanged={(name: string, value?: string | null) => {
                        if (onValueChanged) {
                           setCache(value);
                           onValueChanged(name, value);
                        }
                     }}
                  />
               </Col>
            </Row> : null}
         <Row>
            <Col colSpan={2} className='fill-cell'>
               <Paper variant="outlined" square={false} sx={{ m: 0, p: 1, maxWidth: '80vw' }} >
                  <Typography component="div" variant="body1"> <div dangerouslySetInnerHTML={{ __html: Utils.sanitizeString(cache) ?? '' }} /></Typography>
               </Paper>
            </Col>
         </Row>
      </>
   );
}; 